import { IApiRegistry, ServerInstance } from '../ApiRegistry';
import { IRequestAdapter, RequestAdapters } from '../RequestAdapter';

/**
 * A class to bundle all of the loosely coupled service definitions together
 * and allows for configuration and logging to be controlled in one place
 *
 * @author Masahji C. Stewart
 */
export class CoreService {
  private _api: IApiRegistry;
  private _services: IApiRegistry;
  private _requestAdapters?: Record<string, IRequestAdapter> = {};

  constructor(services?: IApiRegistry) {
    // @ts-ignore solve typescript puzzle
    this._services = services || { ...services };
    this._api = new Proxy<IApiRegistry>(this._services, {
    // @ts-ignore solve typescript puzzle
      set: (obj, prop) => {
        throw new ReferenceError(`api ${String(prop)} cannot be set`);
      },
    });
  }

  clone() {
    return new CoreService(this._services);
  }


  /**
   * @returns a read only object which can access all services defined in this SDK
   *
   * @example
   * coreServiceInstance.api.someService.blahServiceMethod()
   *
   *
   */
  get api(): IApiRegistry {
    return this._api;
  }

  /**
   * @param {string} serviceName
   * @param {string} serviceInstance
   *
   * "registers" (defines) the serviceName as the serviceInstance within this.api
   * registration also means that serviceInstance will be have its `core` instance
   * set to `this`
   *
   * @example
   * coreServiceInstance.register('example', new ExampleService());
   * coreServiceInstance.api.example.someExampleServiceMethod();
   */
  register(serviceName: keyof IApiRegistry, serviceInstance: any): void {
    const instance = serviceInstance as ServerInstance;

    // @ts-ignore TODO solve this typescript puzzle
    this._services[serviceName] = instance;
    serviceInstance.core = this;
  }

  requestAdapter(key?: RequestAdapters): IRequestAdapter {
    const defaultAdapter = this.requestAdapters.default;
    const adapter = key ? (this.requestAdapters[key] || defaultAdapter) : defaultAdapter;

    if (!adapter) {
      throw `${key} RequestAdapter not defined`;
    }

    return adapter;
  }

  set requestAdapters(adapters) {
    this._requestAdapters = adapters;
  }

  get requestAdapters() {
    // TODO fix exceptions here
    if (!this._requestAdapters) throw 'RequestAdapters not defined';
    return this._requestAdapters;
  }

}
